import { arrayToObjectCovert } from '../../../../services/commonService';

const handleFetchUsersFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.users = arrayToObjectCovert(action.payload.data);
  state.usersOrder = action.payload.data.map(user => user.id);
  state.currentPage = action.payload.current_page;
  state.totalPages = action.payload.last_page;
  state.perPage = action.payload.per_page;
  state.totalUsers = action.payload.total;
  state.lastUpdated = action.payload.last_update;
  state.message = action.payload.message;
};

const handleFetchUserIPFulfilled = (state, action) => {
  state.status = 'succeeded';
  if (action.payload.ip) {
    localStorage.setItem('userIP', action.payload.ip);
  }
}

const handleFetchPermissionListFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.permissionList = action.payload;
}

const handleFetchPermissionSpecificUserFulfilled = (state) => {
  state.status = 'succeeded';``
}

const handleFetchOwnerOnboardingListListFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.ownerOnboardingList = action.payload;
}

const handleSavePermissionsFulfilled = (state) => {
  state.status = 'succeeded';
}

const handleAddUserFulfilled = (state, action) => {
  state.status = 'succeeded';
  const userId = action.payload.data.id;
  if (!state.users[userId]) {
    state.users[userId] = [];
  }
  state.users[userId].push(action.payload.data);
  state.message = action.payload.message;
};

const handleFetchUserByIdFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.currentUser = action.payload.data;
};

const handleUpdateUserFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.users[action.payload.data.id] = action.payload.data;
  state.currentUser = action.payload.data;
  state.message = action.payload.message;
};
const handleChangePasswordFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};

const handleFetchBranchUsersFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.branchUsers = action.payload;
  state.message = action.payload.message;
};

const handleFetchActiveUsersFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.activeUsers = action.payload.data;
  state.message = action.payload.message;
};

const handleFetchActivePermissionUsersFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.activePermissionUsers = action.payload.data;
  state.message = action.payload.message;
};

export {
  handleFetchUsersFulfilled,
  handleAddUserFulfilled,
  handleFetchUserByIdFulfilled,
  handleUpdateUserFulfilled,
  handleChangePasswordFulfilled,
  handleFetchBranchUsersFulfilled,
  handleFetchActiveUsersFulfilled,
  handleFetchActivePermissionUsersFulfilled,
  handleFetchPermissionListFulfilled,
  handleFetchPermissionSpecificUserFulfilled,
  handleSavePermissionsFulfilled,
  handleFetchOwnerOnboardingListListFulfilled,
  handleFetchUserIPFulfilled
};
